import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

import MenuModule from '@/modules/menu';
import UsuarioModule from '@/modules/usuario';
import PerfilModule from '@/modules/perfil';
import FoliosModule from '@/modules/folios';
import FoliosOfClienteModule from '@/modules/folios_cliente';

export default new Vuex.Store({
  modules: {
    menu: MenuModule,
    usuario:UsuarioModule,
    perfil:PerfilModule,
    folios:FoliosModule,
    folios_cliente:FoliosOfClienteModule
  }
})


// WEBPACK FOOTER //
// ./src/store/store.js